import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";

import CmeCoachComponent from 'components/forms/CmeCoach';
import LoadingIcon from 'components/LoadingIcon';

import { v2, Hubspot } from 'actions';
import { productPages as ProductPagesSlice } from 'slices';
import Cookies from 'js-cookie';

const { cmeCoachSearch, cmeCoachSendEmail } = v2.cmeCoach.thunks;
const { staticDataFetch } = v2.staticData.thunks;
const { hubspotSubmitCmeCoach } = Hubspot;
const { selectors } = ProductPagesSlice;


const CmeCoachContainer = () => {
  const dispatch = useDispatch();
  const cmeCoach = useSelector(state => state.cmeCoach.data);
  const staticData = useSelector(state => state.staticData);
  const { productPageIds } = cmeCoach;
  const productPages = useSelector(state => selectors.selectAll(state)).filter(page => productPageIds.includes(page.id));


  useEffect(() => {
    dispatch(staticDataFetch());
  }, []);

  const onSubmitEmail = (email) => {
    dispatch(hubspotSubmitCmeCoach(email, Cookies.get('hubspotutk')));
    return dispatch(cmeCoachSendEmail({ email }));
  };

  const onCmeCoachSearch = (selectedSpecialtyId, selectedStateId) => {
    dispatch(cmeCoachSearch({ selectedSpecialtyId, selectedStateId }));
  };

  if (!cmeCoach) return <LoadingIcon />;

  return (
    <CmeCoachComponent
      cmeCoach={cmeCoach}
      specialties={staticData.data.specialties}
      usStates={staticData.data.us_states}
      productPages={productPages}
      onSearch={(selectedSpecialtyId, selectedStateId) => onCmeCoachSearch(selectedSpecialtyId, selectedStateId)}
      onSubmitEmail={email => onSubmitEmail(email)}
    />
  );
};

export default CmeCoachContainer;
